<template>
  <div class="yuanbao-author-rule-wrap">
    <div v-if="ua === 'pc'" class="bd">
      <dl>
        <dd>合作模式分为：<span class="strong">普通授权</span>、<span class="strong">有限排他授权</span>、<span class="strong">转让</span></dd>
        <dd><span class="strong">普通授权</span>：指乙方授权甲方在其产品中使用其壁纸。</dd>
        <dd>
          <span class="strong">有限排他授权</span>：指在桌面壁纸产品领域，乙方仅授权甲方作为其所提供壁纸的许可使用
          方。乙方不得将该壁纸及与该壁纸相同、相似或可能导致他人混淆的其他壁纸直接或间
          接地授权给与甲方产品竞争的其他产品的运营方及其关联方。
        </dd>
        <dd><span class="strong">转让</span>：乙方将其对壁纸享有的著作权项下的除署名权之外的其他权利移交给甲方所有。</dd>
        <dd><span class="strong">※ 协议授权更有利于保护原创作者的作品权益。</span></dd>
      </dl>
    </div>
    <div v-if="ua === 'mobile'" class="bd">
      <dl>
        <dd>实名认证成功，请在<span class="strong">PC端</span>进行签约流程。</dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { fetchUserInfo } from '@/api/user'
// import { fetchContractCheck } from '@/api/signContract'

export default {
  data() {
    return {
      userInfoFresh: null,
      contractCheck: {
        url: '',
        status: 7,
      },
      ua: 'pc',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
      contestConfig: state => state.contestConfig,
    }),
  },
  async mounted() {
    const jump = () => {
      setTimeout(async () => {
        try {
          // await this.fetchContractCheck()
        } catch (e) {
          console.log(e)
        }
        // if (this.contractCheck.url) {
        //   window.location.href = this.contractCheck.url
        // } else {
        //   return jump()
        // }
      }, 1500)
    }
    if (/Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/g.test(navigator.userAgent)) {
      this.ua = 'mobile'
    } else {
      this.ua = 'pc'
      await this.fetchUserInfo()
      jump()
    }
  },

  methods: {
    async fetchUserInfo() {
      if (!this.common.token) {
        this.userInfoFresh = {}
        return
      }
      try {
        const res = await fetchUserInfo({
          common: this.common,
        })
        console.log('fetchUserInfo', res)
        if (res && res.resp_common && !res.resp_common.ret) {
          this.userInfoFresh = res.user_info
        }
      } catch (err) {
        //
      }
    },
    async fetchContractCheck() {
      // const res = await fetchContractCheck()
      // this.contractCheck = res.data
    },
  },
}
</script>

<style scoped lang="scss">
.yuanbao-author-rule-wrap {
  margin: 0 auto;
  z-index: 30;
  position: relative;
  width: 550px;
  height: 380px;
  background: #000;
  color: #fff;
  border-radius: 12px;
  overflow: hidden;
  .btn-close {
    position: absolute;
    right: 8px;
    top: 8px;
    // width: 20px;
    // height: 20px;
    cursor: pointer;
    &:hover {
      &::before {
        background-position: -21px 0;
      }
    }
    &:active {
      &::before {
        background-position: -42px 0;
      }
    }
    &::before {
      content: '';
      display: inline-block;
      width: 21px;
      height: 21px;
      background: url('~@/assets/images/close.png') 0 0 no-repeat;
    }
  }
  .bd {
    width: 420px;
    margin: 0 auto;
  }
  dl {
    padding-top: 40px;
    line-height: 24px;
    font-size: 14px;
    color: #fff;
  }
  dd {
    margin-bottom: 5px;
    padding-left: 8px;
  }
  .strong {
    color: #E88E01;
  }
}
.btn {
  display: block;
  user-select: none;
  cursor: pointer;
  margin: 20px auto;
  width: 240px;
  height: 40px;
  color: #333;
  text-align: center;
  line-height: 40px;
  background: #F4C000;
  border-radius: 8px;
}
</style>
